import React, { useState } from 'react';

const IconBrand = ({ size = 18, stroke = 2, color = "currentColor", hoverColor = "#1890ff", marginRight = 10 }) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="-3 -6 24 28"
            fill="none"
            stroke={isHovered ? hoverColor : color}
            strokeWidth={stroke}
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{
                transition: "stroke 0.5s ease",
                marginRight: `${marginRight}px`, // Espacio a la derecha
                marginLeft: "-4px"
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <path d="M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z" />
            <path d="M8 9h1l3 3l3 -3h1" />
            <path d="M8 15l2 0" />
            <path d="M14 15l2 0" />
            <path d="M9 9l0 6" />
            <path d="M15 9l0 6" />
        </svg>
    );
};

export default IconBrand;
